import axios from 'axios';
const url = `${process.env.REACT_APP_API_BASE_URL}/account/permission-groups`;
export const listPermissionGroups = () => axios.get(url);
export const createPermissionGroup = values => axios.post(url, values);
export const updatePermissionGroup = (id, values) => axios.put(`${url}/${id}`, values);
export const deletePermissionGroup = id => axios.delete(`${url}/${id}`);
